export const COURSE_STEP_TYPE = Object.freeze({
  ENROLMENT: 1,
  IDENTITY_DOCUMENTS: 2,
  USI: 3,
  PRE_TRAINING_REVIEW: 4,
  LLN_TEST: 5,
  PRE_CLASS_PREPARATION: 6,
  READING_LEARNING_PACK: 7,
  READING_VICTORIAN_SAFETY: 8,
  READING_WORKSAFE: 9,
  BOOK_CLASS: 10,
  ATTENDANCE: 11,
  ASSESSMENT: 12,
  COURSE_COMPLETED: 13,
  CERTIFICATE: 14,
});

export const COURSE_STEP_CODE = Object.freeze({
  PRE_TRAINING_REVIEW: "PRE_TRAINING_REVIEW",
  LLN_TEST: "LLN_TEST",
  PRE_CLASS_PREPARATION: "PRE_CLASS_PREPARATION",
  READING_LEARNING_PACK: "READING_LEARNING_PACK",
  READING_VICTORIAN_SAFETY: "READING_VICTORIAN_SAFETY",
  READING_WORKSAFE: "READING_WORKSAFE",
});
